<template>
  <base-card class="metrics-card pt-2 mb-0">
    <div class="d-flex align-items-center mb-4 justify-content-between">
      <div>
        <base-heading class="title-card d-flex align-items-center">
          <slot name="title">
            Outreach by Team Member
          </slot>
        </base-heading>
      </div>
      <div class="d-flex">
        <base-button
          class="px-3 mr-0 d-flex"
          style="border: 1px solid #C6C6C6;"
          nowrap
          small
          :disabled="downloadingReport"
          @click="downloadReport"
        >
          <template v-if="downloadingReport">
            <font-awesome-icon
              :icon="['fas', 'spinner']"
              class="mr-2"
              spin
            />
            <base-text size="s">
              Downloading Data
            </base-text>
          </template>
          <template v-else>
            <base-icon
              icon="download-report"
              class="mr-2"
            />
            <base-text size="s">
              Download Data
            </base-text>
          </template>
        </base-button>
      </div>
    </div>
    <!-- <hr style="border-color: #D4D4D4">  deleted by new design -->
    <template v-if="loading">
      <base-skeleton
        v-for="n in 6"
        :key="n"
        :opacity="0 + (1 /n)"
        class="py-3 my-0"
      >
        <div class="d-flex align-items-center mr-3">
          <div class="w-50">
            <div
              class="skeleton__item"
              style="max-width: 130px"
            />
          </div>
          <div class="d-flex w-50 justify-content-between align-items-center">
            <div
              v-for="m in 4"
              :key="`item_skel_${m}`"
              class="skeleton__item mr-5"
              :style="`max-width: 50px; ${m === 1 ? 'margin-top: 0.5rem;' : ''}`"
            />
          </div>
        </div>
      </base-skeleton>
    </template>
    <template v-else>
      <div class="rows-container">
        <div
          v-for="(label, index) in entries.labels"
          :key="`metric_label_${index}`"
          :class="`row ${index % 2 === 1 ? 'colored' : ''} metric-row`"
        >
          <base-text
            light
            class="col-5"
          >
            {{ label.label }}
          </base-text>
          <div class="col-7 row">
            <base-text
              v-for="(profileStats, p_index) in currentProfiles"
              :key="`metric_value_${p_index}`"
              light
              :class="`text-center w-100 col-3 ${label.key === 'name' ? 'name' : ''}`"
            >
              {{ label.formatter ? label.formatter(profileStats[label.key]) : formatGeneric(profileStats[label.key]) }}
            </base-text>
          </div>
        </div>
        <div class="row d-flex align-items-center justify-content-between pt-4 pb-4">
          <base-pagination
            v-model="currentPage"
            class="mt-n1 mx-auto"
            :count="entries.profiles.length"
            :page-size="pageSize"
          />
        </div>
      </div>
    </template>
  </base-card>
</template>

<script>
import { API_ROOT } from '../../../config';

export default {
  name: 'AdminOutreach',
  props: {
    entries: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 4,
      downloadingReport: false,
    };
  },
  computed: {
    currentProfiles() {
      return this.entries.profiles.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    institutionPk() {
      return this.$store.state.account.user.profile.institution.pk;
    },
  },
  methods: {
    formatGeneric(value) {
      return value === null || value === undefined ? '--' : value;
    },
    downloadReport() {
      this.downloadingReport = true;
      this.$http.get(`${API_ROOT}/weekly-report/${this.institutionPk}`, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/ms-excel' });
          const link = document.createElement('a');
          link.setAttribute('href', URL.createObjectURL(blob));
          link.setAttribute('download', response.headers['content-disposition'].split('filename*=utf-8\'\'')[1]);
          link.click();
          URL.revokeObjectURL(link.href);
        }).then(() => {
          this.downloadingReport = false;
        }).catch((error) => {
          console.error(error);
          this.downloadingReport = false;
        });
      this.$mixpanel.track('download_report', {
        account_id: this.$store.state.account.user.user.email,
      });
    },
  },
};
</script>
<style lang="scss"
       scoped>
.dropdown-arrow {
  position: absolute;
  right: 30px;
}

.metrics-card {
  overflow: hidden;
  ::v-deep .card-body {
    padding-bottom: 0;
  }
}

// .rows-container {
//   margin-left: -44px;
//   margin-right: -44px;
// }
.colored {
  background-color: $gray-light;
}

.metric-row {
  border-bottom: 1px solid #E2E2E2;
  padding: 4px 10px 11px 10px;
  margin: 0 !important;
}

.name {
  // text-decoration: underline;
  font-family: $font-family-sans-serif-medium;
}

.dropdown {
  position: absolute;
  right: 12px;
  overflow: hidden;
  cursor: pointer;

  border: 1px solid #33333350;
  z-index: 9;

  div {
    transition: background-color .3s ease;

    &:hover {
      background-color: $gray-light;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.metrics-tabs {

  &::v-deep .base-tabs__item {
    background-color: $gray-light !important;
  }
}
.title-card {
  font-family: 'Tiempos Headline';
  font-weight: 600;
  font-size: 23px;
  line-height: 120%;
  letter-spacing: 0.01em;
  color: #1B1B1B;
  margin-bottom: unset;
}
</style>
